export const DEFAULT_FILTERS = {
  id: {
    title: 'Form ID',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  },
  created_at: {
    type: 'date-range',
    title: 'Created At',
    icon: 'calendar-2-mono'
  },
  updated_at: {
    type: 'date-range',
    title: 'Updated On',
    icon: 'calendar-2-mono'
  },
  name: {
    title: 'Name',
    placeholder: 'Search by Name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  version: {
    title: 'Version',
    placeholder: 'Search by Version',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'file-text-mono'
  }
};
